import { render, staticRenderFns } from "./MotivoExclusao.vue?vue&type=template&id=fbe66bb0"
import script from "./MotivoExclusao.vue?vue&type=script&lang=js"
export * from "./MotivoExclusao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports